import SettingsTab from './SettingsTab';
import integrationResources from './integration-resources';
import advancedPageSettings from './page-settings/advanced-page-settings';

const siteConfigResources = {
    default: [
        {
            hoverControl: false,
            label: 'Favicon & Social Media Image',
            modules: [
                {
                    path: 'settings/meta/favicon',
                    content: {
                        label: 'Favicon',
                        accept: 'image/*',
                        imageType: 'favicon',
                        template: 'ImagePreview',
                    },
                },
                {
                    path: 'settings/meta/og:image',
                    content: {
                        accept: 'image/*',
                        imageType: 'og:image',
                        template: 'ImagePreview',
                        label: 'Social Media Image',
                        info: 'Recommended 1200px x 630px',
                    },
                },
            ],
        },
    ],
};

export default [
    new SettingsTab({
        title: 'Meta',
        icon: ['far', 'bars'],
        content: siteConfigResources,
    }),
    new SettingsTab({
        icon: ['far', 'plug'],
        title: 'Integrations',
        content: integrationResources,
    }),
    new SettingsTab({
        title: 'Advanced',
        content: advancedPageSettings,
        icon: ['far', 'laptop-code'],
    }),
];
